import template from './loginForm.html';

class LoginFormController {
    constructor($uibModal, LoginService) {
        'ngInject';
        this.$uibModal = $uibModal;
        this.LoginService = LoginService;
    }

    $onInit() {
        this.email = this.email || '';
    }

    login(email, password) {
        this.LoginService.login(email, password).then(this.onLogin);
    }

    openForgotPwModal() {
        let email = this.email;
        let modalInstance = this.$uibModal.open({
            backdropClass: 'mms-backdrop',
            component: 'mmsForgotPasswordModal',
            resolve: {
                email() {
                    return email;
                },
            },
            windowClass: 'modal-pw'
        });
        modalInstance.result.catch(() => {});
    }
}

export const LoginFormComponent = {
    name: 'loginForm',
    component: {
        template: template,
        controller: LoginFormController,
        bindings: {
            email: '<emailAddress',
            onLogin: '&'
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/pages/login/loginForm.component.js